export default __webpack_public_path__ + "static/infantil-9b11830e786bf9a91bffd84158503422.png";